/** @format */
export enum BasketProductState {
    SHIPPED = 'Shipped',
    ONLINE = 'Online',
    OFFLINE = 'Offline',
    ALLOCATED = 'Allocated',
}
